import { routes } from "configs";

export const PACKAGE_ASSESSMENT_ACCESS_ROUTES = [
  routes.students,
  routes.studentsAssignments,
  routes.teacherSectionsNew,
  routes.teacherSection,
  routes.teacherSectionsEdit,
  routes.teacherSectionShowStudents,
  routes.teacherSectionStudent,
  routes.teacherSectionStudentNew,
  routes.teacherSectionStudentEdit,
  routes.teacherSections,
  routes.teacherSectionsArchivedAssignments,
  routes.teacherSectionsAssignments,
  routes.teacherSectionEditAssignment,
  routes.teacherSectionSnapshotAssignment,
  routes.studentAssignment,
  routes.teacherAssessments,
  routes.teacherAssessmentsArchived,
  routes.teacherAssessmentsPending,
  routes.teacherAssessmentsNew,
  routes.teacherAssessmentsEdit,
  routes.teacherAssessment,
  routes.teacherAssessmentShare,
  routes.teacherSectionAssignment,
  routes.teacherSectionAssignmentResult,
  routes.packageAssessments,
];

export const SCOPE_ACCESS_ROUTES = [
  routes.planner,
  routes.scopes,
  routes.scope,
  routes.scopeNav,
  routes.bookmarks,
  routes.toolbox,
  routes.section,
  routes.element,
  routes.rootStandards,
  routes.standards,
];
